import { render } from "./document.vue?vue&type=template&id=457500e5&ts=true"
import script from "./document.vue?vue&type=script&lang=ts"
export * from "./document.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__